import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/(app)/(store)/product/$productId/')({
    component: RouteComponent,
})
function RouteComponent(){
    return(
        <div>hello</div>
    )
}
